var map = {
	"./1f1fa-1f1f8.svg": 254,
	"./1f600.svg": 255,
	"./1f601.svg": 256,
	"./1f603.svg": 257,
	"./1f60d.svg": 258,
	"./1f60f.svg": 259,
	"./1f610.svg": 260,
	"./1f612.svg": 261,
	"./1f61e.svg": 262,
	"./1f61f.svg": 263,
	"./1f621.svg": 264,
	"./1f625.svg": 265,
	"./1f62a.svg": 266,
	"./1f62c.svg": 267,
	"./1f62e.svg": 268,
	"./1f631.svg": 269,
	"./1f633.svg": 270,
	"./1f638.svg": 271,
	"./1f914.svg": 272,
	"./2764.svg": 273
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;



/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/twemoji ^\.\/.*$
 ** module id = 480
 ** module chunks = 0
 **/